import React from 'react'

function TenderTextPutz() {
  return (
    <embed src="\pdfs\DAT2.2.3_PKS_Putz-Kuehldeckensystem_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextPutz